import PropTypes from 'prop-types';
import { parseMarkdown } from './utils';
import css from './index.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Text = function Text(_ref) {
  var description = _ref.description,
      title = _ref.title;

  if (!description) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.panelTitle,
      children: [title, ":"]
    }), /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: parseMarkdown(description)
      }
    })]
  });
};

Text.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string
};
export default Text;